"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _default = function _default()
/*{globalVariables={}}={}*/
{
  var modalStyle = {
    position: 'fixed',
    zIndex: 1040,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  };
  return {
    OverlayModal: modalStyle,
    OverlayModalContent: {
      position: 'absolute',
      width: 400,
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      border: '1px solid #e5e5e5',
      backgroundColor: 'white',
      boxShadow: '0 5px 15px rgba(0,0,0,.5)',
      outline: 'none',
      '&.bordered': {
        border: '4px #d3d3d3 solid',
        borderRadius: '5px'
      }
    },
    OverlayModalBackdrop: _objectSpread(_objectSpread({}, modalStyle), {}, {
      zIndex: 'auto',
      backgroundColor: '#000',
      opacity: 0.5
    }),
    OverlayModalTitle: {
      padding: [15, 20],
      fontWeight: 600,
      backgroundColor: '#f4f4f4',
      background: 'linear-gradient(to bottom, #f9f9f9, #ececec 100%)',
      backgroundRepeat: 'repeat-x'
    },
    OverlayModalInnerContent: {
      padding: 20
    },
    OverlayModalFooter: {
      padding: 20
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map